module.exports = __webpack_public_path__ + "static/media/cowboy_boots_desktop.0007cd40.jpg";